/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 51,
  image: "default-changelog-v2.png",
  title: "Platform Features & Improvements",
  shortDescription: "In the latest platform version, we introduce a feature for viewing subscription usage history and enhance various aspects of the platform, including streamlined data uploads, organized bucket management, and fixes for subscription renewals and instance management.",
  description: "In the latest platform version, we introduce a feature for viewing subscription usage history and enhance various aspects of the platform, including streamlined data uploads, organized bucket management, and fixes for subscription renewals and instance management.",
  date: "Nov 20th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron"]
};
export const content = `
## Subscription Usage History

We are excited to introduce a new feature allowing you to view your subscription usage history. This addition enables you to gain deeper insights into your usage patterns. Simply select the subscription you wish to review, and you'll be able to see a detailed history of your usage. This feature is designed to give you better clarity and control over your subscription activities.

## Platform Enhancements and Fixes

- **Subscription Renewal Fix:** Corrected processing issues for subscription renewals using credits as the payment method.
- **Persistent Storage Update:** Fixed automatic preselection of the recommended persistent storage plan during instance creation and updates.
- **Public Storage Organization Expansion:** Extended our public organization feature to include storage organizations.
- **Routing Issue Resolution:** Fixed a routing problem preventing users from being directed to the \`/new-instance\` page during redeployment when the organization changes.
- **New Confirmation Modal:** When switching deployment types on the redeploy page, a confirmation prompt was added.
- **Compute Metrics Issue Fix:** Addressed occasional issues fetching instance metrics for on-demand instances.
- **Region Addition for On-Demand Instances:** Introduced **'us-east'** as a new region for deploying on-demand instances.

## Buckets & Uploads Enhancements

- **Streamlined Upload Process:** Revamped the data upload interface for better efficiency. Now supports multiple simultaneous uploads managed via the bottom right bar of the UI.
- **Simultaneous Uploads with Progress Tracking:** Real-time progress tracking for each upload, visible and continuously updated in the bottom right of the screen.
- **Bucket Order Optimization:** Buckets are now organized by the latest upload, simplifying the tracking of recent activities.
- **Enhanced Arweave Integration:** Updated the CID column to display the Arweave transaction ID (txID) for clearer and more direct insight into Arweave transactions.
  `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
